var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-description-widget widget"},[_c('div',{staticClass:"d-flex"},[_c('label',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.$t("common.description"))+" ")])]),_c('div',{staticClass:"card pa"},[_c('p',{staticClass:"mb-0 text-formatted"},[_vm._v(_vm._s(_vm.group.short_description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }